import { Box, Container, Typography } from "@mui/material";
import {
  Content,
  HomeImage,
  Root,
  HomeSite,
  HomeSiteContainer,
  Title,
  Band,
  ButtonGoToCustomerSite,
  TextCustomer,
  CustomeSiteText,
  AddressSiteText,
} from "./HomePage.styles";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import HomeImg from "../../../assets/images/Fruy-x-Vandewiele-151-of-259.jpg";
import HomeBackgroundSavio from "../../../assets/images/home_background_savio.jpg";
import GoToPage from "../../../components/GoToPage/GoToPage";
import { useUserInfo } from "../../../../explorer/hooks/useUserInfo";
import AppIconsArrow1 from "../../../components/AppIcons/AppIconsArrow1";
import SearchBarSitesMachines from "../../../components/SearchBarSitesMachines/SearchBarSitesMachines";
import useBrands from "../../../../explorer/hooks/useBrands";
import useCurrentSite from "../../../hook/useCurrentSite";

const HomePage = () => {
  const [userInfo] = useUserInfo();

  const { t } = useTranslation();
  const { currentBrand } = useBrands();

  const brandIsEnabled =
    currentBrand?.disabled === null ? true : !currentBrand?.disabled;

  return (
    <Root>
      <Container>
        <Title>
          <b>{t("common.homepage.welcome")} </b>
          {`${userInfo?.firstName} ${userInfo?.lastName}`}
        </Title>
        {!brandIsEnabled && <DisabledHomepageContent />}
      </Container>
      {brandIsEnabled && <EnabledHomepageContent />}
      <Band />
    </Root>
  );
};

const EnabledHomepageContent = () => {
  const [currentSite, setCurrentSite] = useCurrentSite();
  const { t } = useTranslation();
  const currentBrand = useBrands().currentBrandUrl;

  let backgroundImage = null;
  switch (currentBrand) {
    case "savio":
      backgroundImage = HomeBackgroundSavio;
      break;
    default:
      backgroundImage = HomeImg;
      break;
  }

  return (
    <Content>
      <HomeImage sx={{ backgroundImage: `url(${backgroundImage})` }}>
        <HomeSiteContainer>
          <HomeSite>
            <CustomeSiteText sx={{ mb: 1 }}>
              {t("common.homepage.selectedcustomersite")}
            </CustomeSiteText>

            <TextCustomer variant="h5">
              <AddressSiteText>{currentSite.customerSiteCode}</AddressSiteText>
              {currentSite.customerSiteName} <br />
              <AddressSiteText>
                {currentSite.address} {currentSite.city} {currentSite.zipCode} (
                {currentSite.country})
              </AddressSiteText>
            </TextCustomer>
            <GoToPage
              page="spareparts.installedbase"
              params={{
                customerSiteCode: currentSite.customerSiteCode,
              }}
            >
              <ButtonGoToCustomerSite className="osh-hint-gotocustomersite">
                <AppIconsArrow1 />
              </ButtonGoToCustomerSite>
            </GoToPage>
          </HomeSite>
        </HomeSiteContainer>
        <SearchBarSitesMachines />
      </HomeImage>
    </Content>
  );
};

const DisabledHomepageContent = () => {
  const { t } = useTranslation();
  return (
    <Box mt="100px">
      <Typography variant="h5">{t("common.homepage.brandDisabled")}</Typography>
    </Box>
  );
};

export default HomePage;
